import {USER_ERROR, USER_SUCCESS, USER_REQUEST} from '../actions/user'
import {AUTH_LOGOUT} from '../actions/auth'
// import {ACCOUNT_REQUEST, fetchAccount} from '../actions/account'

// import { fetchContacts } from '@/store/actions/contact'
// import apiCall from '@/utils/api.js'
import { mock, userData } from '../../utils/mockdata';

var axios = require('axios');

import Vue from 'vue'


export default {

  state: {
    status: '',
    profile: {},
  },
  mutations: {
    [USER_REQUEST]: (state) => {
      state.status = 'loading'
    },
    [USER_SUCCESS]: (state, resp) => {
      state.status = 'success';
      Vue.set(state, 'profile', resp)

      console.log(JSON.stringify(resp))
    },
    [USER_ERROR]: (state) => {
      state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
      state.profile = {}
    }
  },
  actions: {
    [USER_REQUEST]: ({commit, dispatch}) => {
      commit(USER_REQUEST);
      // apiCall({url: 'user/me'})
      //   .then(resp => {
      //     commit(USER_SUCCESS, resp)
      //     // dispatch(ACCOUNT_REQUEST, profile.accoundid)
      //     // console.log("resp > "+ JSON.stringify(resp))
      //     // console.log("user > "+ JSON.stringify(store.getUserProfile))
      //     dispatch('fetchAccount', '1')
      //     dispatch('fetchMembers', '1')
      //     dispatch('fetchContacts', '1')
      //     dispatch('fetchActivities', '1')
      //     dispatch('fetchEvents', '1')

      //   })
      //   .catch( (resp) => {
      //     console.log(resp)
      //     commit(USER_ERROR);
      //     // if resp is unauthorized, logout, to
      //     dispatch(AUTH_LOGOUT)
      //   })

        mock.onGet('user/me', { params: { userid: '1' }  }).reply(
          200, {data: userData[0]}
        )
        
        axios.get('/user/me', { params: { userid: '1' } } )
        .then(resp => {
          console.log("resp > " + JSON.stringify(resp))
          commit(USER_SUCCESS, resp.data.data)

          dispatch('fetchAccount', '1')
          dispatch('fetchMembers', '1')
          dispatch('fetchContacts', '1')
          dispatch('fetchActivities', '1')
          dispatch('fetchEvents', '1')

            // commit('setActivities', resp.data.data),
            // console.log("activities fetched. > " + resp.data.data.length)
        })
        .catch( (resp) => {
          console.log(resp)
          commit(USER_ERROR);
          // if resp is unauthorized, logout, to
          dispatch(AUTH_LOGOUT)
        })

    },
  },
  getters: {
    getUserProfile: state => state.profile,
    isUserProfileLoaded: state => !!state.profile.name,
  }

}

// == Default structure ==
// export default {
//   state: {},
//   mutations: {},
//   actions: {},
//   getters: {}
// }
